import _ from "lodash"

import actionTypes from "@actions/actionTypes"

export const initialState = {
  notifications: [], // notifications
  loading: false,
  openedFromNotification: false,
  lastSeenTimestamp: null,
  unreadCount: 0, // Wave 3 NC1: notification-center badge count (TOTAL unread, wave4-notif-conform)
  hasMore: false, // wave4-notif-conform: lazy-load pagination -- more history to fetch
  categoryCounts: {}, // wave4-notif-conform: { categoryId: unreadCount } for the category rail
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT: {
      return _.assign({}, initialState)
    }

    case actionTypes.GET_NOTIFICATIONS: {
      let updates = { loading: true }
      return _.assign({}, state, updates)
    }

    case actionTypes.GOT_NOTIFICATIONS: {
      let notifications = action.payload

      let updates = { notifications, loading: false }

      return _.assign({}, state, updates)
    }

    // wave4-notif-conform: lazy-load pagination -- APPENDS the next page instead of replacing the
    // list (GOT_NOTIFICATIONS above stays the "replace/reset" case, e.g. first load or a category
    // switch).
    case actionTypes.APPENDED_NOTIFICATIONS_PAGE: {
      const existingIds = new Set(state.notifications.map(n => n.id))
      const newOnes = (action.payload || []).filter(n => !existingIds.has(n.id))
      return _.assign({}, state, {
        notifications: [...state.notifications, ...newOnes],
        loading: false,
      })
    }

    case actionTypes.SET_NOTIFICATIONS_HAS_MORE: {
      return _.assign({}, state, { hasMore: !!action.payload })
    }

    case actionTypes.SET_NOTIFICATION_CATEGORY_COUNTS: {
      return _.assign({}, state, { categoryCounts: action.payload || {} })
    }

    case actionTypes.GET_NOTIFICATIONS_ERROR: {
      let updates = { loading: false }
      return _.assign({}, state, updates)
    }

    case actionTypes.READ_NOTIFICATION: {
      // MERGE, don't replace: action.payload is often just {id} (e.g. from the clear-on-open
      // bulk mark-read path), and replacing the row wholesale wiped teeupId/coId/actorId/etc off
      // the notification, leaving only {id, read:true}. Spread the EXISTING row and flip read.
      const notifications = state.notifications.map(n =>
        n.id === action.payload.id ? { ...n, ...action.payload, read: true } : n
      )

      let updates = { notifications }

      return _.assign({}, state, updates)
    }

    case actionTypes.REMOVE_NOTIFICATION: {
      const notifications = state.notifications.filter(
        n => n.id !== action.payload.id
      )

      let updates = { notifications }

      return _.assign({}, state, updates)
    }

    case actionTypes.SET_UNREAD_NOTIFICATIONS_COUNT: {
      return _.assign({}, state, { unreadCount: action.payload })
    }

    case actionTypes.UPDATE_NOTIFICATION_LAST_SEEN: {
      let updates = {}
      if (state.notifications.length > 0) {
        updates.lastSeenTimestamp = state.notifications[0].createdat
      }

      return _.assign({}, state, updates)
    }

    default:
      return state
  }
}
